export { default as NLog, logProps } from './src/Log';
